import React from 'react'
import Skeleton from 'react-loading-skeleton'

const OrderCardSkeleton = () => {
  return <Skeleton width={'100%'} height={350} />
}

export default OrderCardSkeleton
